export default __webpack_public_path__ + "static/media/background.32f200af.png";